const capitalize = string => {
  const firstLetter = string[0];
  const rest = string.slice(1);
  const capitalizedFirstLetter = firstLetter.toUpperCase();
  return capitalizedFirstLetter + rest;
};

export default capitalize;
